import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Button, Col, Image, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const FollowingHashtags: React.FC<any> = ({ hashTagData, unFollowHashTag }) => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	const goToDetailPage = (id: any) => {
		navigate(`/hashtag/profile/${id}`);
	};

	return (
		<>
			{hashTagData?.length > 0 ? (
				hashTagData?.map((res: any, index: any) => (
					<Col key={`${res?.hashtag}-${index}`} xxl={4} md={6}>
						<Stack className="connections-box gap-3">
							<div className="d-flex gap-3">
								<div
									className="connections-box-profile position-relative"
									onClick={() => goToDetailPage(res?.id)}
								>
									<Image
										src={IMAGE_PATHS.Hashtag}
										alt="logo"
										className="w-100 h-100"
										loading="lazy"
									/>
								</div>
								<Stack className="gap-2 flex-1">
									<h6 className="fw-bold mb-0" onClick={() => goToDetailPage(res?.id)}>
										#{res.hashTag}
									</h6>
									<p className="mb-0">
										{res?.count} {translate('Common.followers')}{' '}
									</p>
									<div className="d-flex gap-2 mt-auto">
										<Button
											onClick={() => unFollowHashTag(res?.id)}
											className="gray-transparent-btn rounded-pill lh-1"
										>
											{translate('Common.unFollow')}
										</Button>
									</div>
								</Stack>
							</div>
						</Stack>
					</Col>
				))
			) : (
				<Col>
					<Stack className="posted-job-box">
						<p className="mb-0">{translate('Common.noHashtagFound')} </p>
					</Stack>
				</Col>
			)}
		</>
	);
};

export default FollowingHashtags;
